import { isValid, parse } from 'date-fns';

export function dateToStringFormat(date: Date, format: 'yyyyMMdd' | 'yyyy/MM/dd' | 'yyyy-MM-dd' = 'yyyyMMdd') {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  switch (format) {
    case 'yyyyMMdd':
      return year + month + day;
    case 'yyyy/MM/dd':
      return [year, month, day].join('/');
    case 'yyyy-MM-dd':
      return [year, month, day].join('-');
    default:
      throw new Error('Invalid format');
  }
}

export const stringToDateFormat = (value: string, formats: string[] = ['yyyyMMdd', 'yyyy/MM/dd', 'yyyy-MM-dd']) => {
  for (let format of formats) {
    const parsedDate = parse(value, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }
  return null;
};
